import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../../components/common/Navbar';
import { useOrdererProfile } from '../../hooks/useOrdererProfile';
import { computeOrdererBadge, ORDERER_BADGE_CONFIG } from '../../utils/ordererBadge';
import { COLORS, SHADOWS } from '../../styles/tokens';

export default function OrdererProfile() {
  const { ordererId } = useParams();
  const navigate      = useNavigate();
  const { profile, loading, error } = useOrdererProfile(ordererId);

  const badgeKey = profile
    ? computeOrdererBadge({ orderCount: profile.orderCount ?? 0, tippiVerified: profile.tippiVerified === true })
    : null;
  const badge = badgeKey ? ORDERER_BADGE_CONFIG[badgeKey] : null;
  const name  = profile?.companyName || profile?.name || 'Bestiller';

  return (
    <div style={styles.root}>
      <Navbar />
      <div style={styles.page}>
        <button
          className="tippi-btn-secondary"
          style={styles.backBtn}
          onClick={() => navigate('/driver')}
        >
          ← Tilbake til dashboard
        </button>

        <div style={styles.card}>
          {loading && <Skeleton />}

          {!loading && error === 'not_found' && (
            <p style={styles.stateText}>Bestiller ikke funnet.</p>
          )}

          {!loading && error && error !== 'not_found' && (
            <p style={styles.stateText}>Kunne ikke laste profil.</p>
          )}

          {!loading && !error && profile && (
            <>
              <div style={styles.badgeIconLarge}>{badge.icon}</div>
              <h2 style={styles.name}>{name}</h2>
              <div style={styles.badgeLine}>
                <span style={{ ...styles.badgeLabel, color: badge.color }}>
                  {badge.label}
                </span>
                <span style={styles.orderCount}>
                  · {profile.orderCount ?? 0} bestillinger
                </span>
              </div>
              {profile.bio && (
                <p style={styles.bio}>{profile.bio}</p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function Skeleton() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
      <div className="skeleton" style={{ width: 56, height: 56, borderRadius: '50%' }} />
      <div className="skeleton" style={{ width: 180, height: 22 }} />
      <div className="skeleton" style={{ width: 120, height: 16 }} />
    </div>
  );
}

const styles = {
  root:         { minHeight: '100vh', background: COLORS.bg, display: 'flex', flexDirection: 'column' },
  page:         { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '32px 20px' },
  backBtn:      { alignSelf: 'flex-start', marginBottom: 24, padding: '9px 16px', borderRadius: 8, border: '1.5px solid #ddd', background: '#fff', fontSize: 14, cursor: 'pointer', color: COLORS.textDark },
  card:         { background: '#fff', borderRadius: 14, padding: '40px 36px', width: '100%', maxWidth: 420, boxShadow: SHADOWS.md, textAlign: 'center' },
  badgeIconLarge: { fontSize: 52, marginBottom: 12 },
  name:         { fontSize: 22, fontWeight: 700, color: COLORS.primary, margin: '0 0 8px' },
  badgeLine:    { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 6, marginBottom: 16 },
  badgeLabel:   { fontWeight: 700, fontSize: 15 },
  orderCount:   { fontSize: 14, color: COLORS.textMid },
  bio:          { fontSize: 14, color: COLORS.textMid, lineHeight: 1.6, margin: '16px 0 0', borderTop: '1px solid #f0f0f0', paddingTop: 16, textAlign: 'left' },
  stateText:    { color: COLORS.textMid, textAlign: 'center', padding: '20px 0' },
};
